import * as Yup from 'yup'
import {
  ACTION,
  ALLOCATION,
  ALLOCATION_UNIT,
  BID_CAP,
  BUDGET,
  DIGITAL_ALLOCATION_IMPRESSIONS,
  DIGITAL_ALLOCATION_TYPE,
  DIGITAL_ALLOCATION_TYPE_BUDGET,
  DIGITAL_ALLOCATION_TYPE_IMPRESSIONS,
  GENDER_FEMALE,
  GENDER_MALE,
  NAME,
  RIGHT_TYPE,
  RIGHT_TYPE_DIGITAL,
  RIGHT_TYPE_ONSITE,
  RIGHT_TYPE_OTHER,
  RIGHT_TYPE_POSTS
} from './fields'
import {
  START_DATE,
  END_DATE,
  endDateReusableValidation
} from '../../../ReusableFormFields/StartEndDateRangeFields/fields'

export const allocationValidation = Yup.number().required('Please enter an allocation')
export const allocationUnitValidation = Yup.string().required('Please select allocation unit')

export const rightNameValidation = Yup.string()
  .required('Please enter name')
  .max(255, 'Name should have maximum 255 characters')

export const rightAgeValidation = Yup.object().test({
  message: 'Please select at least one age range',
  test: value => !!Object.keys(value).filter(ageRange => value[ageRange]).length
})

export const rightGenderValidation = Yup.object().test({
  message: 'Please select at least one gender',
  test: value => value[GENDER_MALE] || value[GENDER_FEMALE]
})

export const reusableRightValidation = isGamAccountConnected => {
  return {
    [NAME]: rightNameValidation,
    [START_DATE]: Yup.string().when(RIGHT_TYPE, {
      is: rightType => rightType === RIGHT_TYPE_DIGITAL || (rightType === RIGHT_TYPE_ONSITE && isGamAccountConnected),
      then: () => Yup.string().required('Please select start date')
    }),
    [END_DATE]: endDateReusableValidation.when(RIGHT_TYPE, {
      is: rightType => rightType === RIGHT_TYPE_DIGITAL || (rightType === RIGHT_TYPE_ONSITE && isGamAccountConnected),
      then: () => Yup.string().required('Please select end date')
    }),
    [ACTION]: Yup.string().max(100, 'Action should have maximum 100 characters'),
    // validation for right with 'other' and 'POSTS' type
    [ALLOCATION]: Yup.number().when(RIGHT_TYPE, {
      is: rightType => rightType === RIGHT_TYPE_OTHER || rightType === RIGHT_TYPE_POSTS,
      then: () => allocationValidation
    }),
    [ALLOCATION_UNIT]: Yup.string().when(RIGHT_TYPE, {
      is: RIGHT_TYPE_OTHER,
      then: () => allocationUnitValidation
    }),
    [BUDGET]: Yup.string().when(RIGHT_TYPE, {
      is: RIGHT_TYPE_DIGITAL,
      then: () =>
        Yup.string().when(DIGITAL_ALLOCATION_TYPE, {
          is: allocationType => allocationType === DIGITAL_ALLOCATION_TYPE_BUDGET,
          then: () => Yup.string().required('Please enter budget')
        })
    }),
    [DIGITAL_ALLOCATION_IMPRESSIONS]: Yup.string().when(RIGHT_TYPE, {
      is: RIGHT_TYPE_DIGITAL,
      then: () =>
        Yup.string().when(DIGITAL_ALLOCATION_TYPE, {
          is: allocationType => allocationType === DIGITAL_ALLOCATION_TYPE_IMPRESSIONS,
          then: () => Yup.string().required('Please enter impressions')
        })
    }),
    [BID_CAP]: Yup.string().when(RIGHT_TYPE, {
      is: RIGHT_TYPE_DIGITAL,
      then: () =>
        Yup.string().when(DIGITAL_ALLOCATION_TYPE, {
          is: allocationType => allocationType === DIGITAL_ALLOCATION_TYPE_IMPRESSIONS,
          then: () => Yup.string().required('Please enter bid cap')
        })
    })
  }
}
